if (!customElements.get('pups-garment-options')) {
  customElements.define(
    'pups-garment-options',
    class PupsGarmentOptions extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced === 'true') return;
        this.dataset.enhanced = 'true';

        if (!window.PupsGarmentHistoryBound) {
          window.PupsGarmentHistoryBound = true;
          window.addEventListener('popstate', () => {
            const visibleProductInfo = document.querySelector('product-info');
            if (!visibleProductInfo?.dataset.url) return;

            const visibleProductPath = new URL(visibleProductInfo.dataset.url, window.location.origin).pathname;
            if (visibleProductPath !== window.location.pathname) window.location.reload();
          });
        }

        this.productInfo = this.closest('product-info');
        this.details = this.querySelector('[data-garment-details]');
        this.status = this.querySelector('[data-switch-status]');
        this.choices = [...this.querySelectorAll('[data-garment-choice]')];

        const breedLink = this.productInfo?.querySelector('.pups-breed-link');
        const sizeChartLink = this.productInfo?.querySelector('.pups-size-chart-link--purchase-row');
        if (breedLink && sizeChartLink && !breedLink.contains(sizeChartLink)) {
          breedLink.classList.add('pups-breed-link--with-size-chart');
          breedLink.append(sizeChartLink);
        }

        if (this.productInfo) {
          this.productInfo.dataset.updateUrl = 'false';

          if (typeof this.productInfo.updateURL === 'function') {
            const originalUpdateURL = this.productInfo.updateURL.bind(this.productInfo);
            this.productInfo.updateURL = (productUrl, variantId) => {
              originalUpdateURL(productUrl, variantId);
              this.updateBrowserURL(productUrl, variantId);
            };
          }
        }

        if (
          typeof subscribe === 'function'
          && typeof PUB_SUB_EVENTS !== 'undefined'
          && PUB_SUB_EVENTS.variantChange
        ) {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            this.updateSelectedPrice(event);
          });
        }

        this.details?.addEventListener('toggle', () => {
          if (this.details.open) this.prefetchAlternates();
        });

        this.choices.forEach((choice) => {
          choice.addEventListener('click', (event) => this.selectGarment(event, choice));
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      prefetchAlternates() {
        if (!this.productInfo || this.dataset.prefetched === 'true') return;

        this.dataset.prefetched = 'true';
        const sectionId = this.productInfo.dataset.originalSection || this.productInfo.dataset.section;
        if (!sectionId) return;

        window.PupsGarmentSectionCache ||= new Map();

        this.choices.forEach((choice) => {
          if (choice.dataset.current === 'true') return;

          const requestUrl = `${choice.dataset.productUrl}?section_id=${encodeURIComponent(sectionId)}`;
          if (window.PupsGarmentSectionCache.has(requestUrl)) return;

          const request = fetch(requestUrl, { credentials: 'same-origin' })
            .then((response) => {
              if (!response.ok) throw new Error(`Unable to prepare shirt style: ${response.status}`);
              return response.text();
            })
            .catch(() => {
              window.PupsGarmentSectionCache.delete(requestUrl);
              return undefined;
            });

          window.PupsGarmentSectionCache.set(requestUrl, request);
        });
      }

      selectGarment(event, choice) {
        if (choice.dataset.current === 'true') {
          event.preventDefault();
          if (this.details) this.details.open = false;
          return;
        }

        if (
          !this.productInfo
          || typeof publish !== 'function'
          || typeof PUB_SUB_EVENTS === 'undefined'
          || !PUB_SUB_EVENTS.optionValueSelectionChange
        ) {
          return;
        }

        event.preventDefault();
        if (this.dataset.switching === 'true') return;

        this.dataset.switching = 'true';
        this.setAttribute('aria-busy', 'true');
        choice.dataset.switching = 'true';
        this.status.textContent = this.dataset.loadingLabel;

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event: { target: choice },
            target: choice,
            selectedOptionValues: [],
          },
        });

        window.setTimeout(() => {
          if (!this.isConnected) return;
          this.dataset.switching = 'false';
          this.removeAttribute('aria-busy');
          delete choice.dataset.switching;
          this.status.textContent = '';
        }, 12000);
      }

      updateSelectedPrice({ data } = {}) {
        const sectionId = this.productInfo?.dataset.originalSection || this.productInfo?.dataset.section;
        if (!data?.html || (data.sectionId && sectionId && data.sectionId !== sectionId)) return;

        const sourceOptions = data.html.querySelector('pups-garment-options');
        if (!sourceOptions) return;

        [
          '.pups-garment-options__summary-meta',
          '[data-current="true"] .pups-garment-options__meta',
        ].forEach((selector) => {
          const sourcePrice = sourceOptions.querySelector(selector);
          const currentPrice = this.querySelector(selector);
          if (sourcePrice && currentPrice) currentPrice.innerHTML = sourcePrice.innerHTML;
        });
      }

      updateBrowserURL(productUrl, variantId) {
        const currentUrl = new URL(window.location.href);
        const nextUrl = new URL(productUrl, window.location.origin);
        const transientParams = new Set(['variant', 'section_id', 'option_values']);

        currentUrl.searchParams.forEach((value, key) => {
          if (transientParams.has(key) || nextUrl.searchParams.has(key)) return;
          nextUrl.searchParams.append(key, value);
        });

        if (variantId) nextUrl.searchParams.set('variant', variantId);
        const historyMethod = currentUrl.pathname === nextUrl.pathname ? 'replaceState' : 'pushState';
        window.history[historyMethod]({}, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
      }
    }
  );
}
